import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isPasswordStrong(value: string): boolean {
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumeric = /[0-9]/.test(value);
  const hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
  const isValidLength = value.length >= 8;

  return (
    hasUpperCase &&
    hasLowerCase &&
    hasNumeric &&
    hasSpecial &&
    isValidLength
  );
}

export function passwordValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value || '';
  const passwordValid = isPasswordStrong(value);

  return passwordValid ? null : { passwordStrength: true };
}

export function passwordsMatchValidator(form: AbstractControl) {
  const password = form.get('password')?.value;
  const confirmPassword = form.get('confirm_password')?.value;
  if (password !== confirmPassword) {
    form.get('confirm_password')?.setErrors({ mismatch: true });
  } else {
    form.get('confirm_password')?.setErrors(null);
  }
  return null;
}
